import React, { Fragment } from "react";
import { FormBlock, FormTitle } from "../../generalStyles/mixin";
import "react-tabs/style/react-tabs.css";
import {
  Detail,
  DetailFlowContent,
  DetailBlockItemBlue,
  DetailBlockItemRed,
  DetailBlockItemGreen,
  DetailBlockItemTitle,
  DetailBlockItemDate,
  DetailBlockItemImg,
  FlowDetailBlock,
  FlowDetailBlockImg,
  ButtonBlock
} from "./styles";
import * as env from "../../environment";
import { Link } from "react-router-dom";
import Buttons from "../button";
import { format } from "date-fns";
import Modal from "../modal";
import Template from "../modal/tempalte";
const { API_URL_MOTOR } = env[process.env.NODE_ENV];

class DetailComponent extends React.Component {
  constructor() {
    super();
    this.goBack = this.goBack.bind(this);
    this.state = {
      idOrder: String,
      trxdetail: [],
      paymentdetail: [],
      resultsBox: [],
      resultTraza: [],
      isOpen: false,
      modalChildren: "",
      isClosable: false,
      request:"",
      response:"",
      engineId: "",
      mostrarComponente: true
    };
  
  }

  goBack(){
      this.props.history.goBack();
  }

  componentDidMount() {
    // Obtenemos el id de la orden desde parametro en la url
    const { idOrder, engineId } = this.props.otroDato;
    this.setState({ idOrder: idOrder });

    // buscar detalle transacciones
    //let endpointTrx = `${API_URL_MOTOR}/api/transaction/get`;
    //this.searchDetailTransaction(endpointTrx, idOrder);

    // buscar detalle medios de pago
    //let endpointPay = `${API_URL_MOTOR}/api/paymentmethod/get`;
    //this.searchDetailPayment(endpointPay, idOrder);

    // buscar cajas
    let endpointBoxes =
      `${API_URL_MOTOR}/api/instance`
    this.searchBox(endpointBoxes, engineId);

    // buscar traza
    let endpointTraza =
    `${API_URL_MOTOR}/api/instance`
    this.searchTrazaDetail(endpointTraza, engineId);
  }

  componentWillReceiveProps(nextProps) {

    if (nextProps.idOrder !== this.state.idOrder &&
      nextProps.engineId !== this.state.engineId) {

      const { idOrder, engineId } = nextProps.otroDato;
      this.setState({
        idOrder: idOrder,
        engineId: engineId,
        mostrarComponente: true
      });

      // buscar detalle transacciones
      //let endpointTrx = `${API_URL_MOTOR}/api/transaction/get`;
      //this.searchDetailTransaction(endpointTrx, idOrder);

      // buscar detalle medios de pago
      //let endpointPay = `${API_URL_MOTOR}/api/paymentmethod/get`;
      //this.searchDetailPayment(endpointPay, idOrder);

      // buscar cajas
      let endpointBoxes =
        `${API_URL_MOTOR}/api/instance`
      this.searchBox(endpointBoxes, engineId);

      // buscar traza
      let endpointTraza =
        `${API_URL_MOTOR}/api/instance`
      this.searchTrazaDetail(endpointTraza, engineId);
    }

  }

  searchHistory = (endpoint, params,boxName,indextraza) => {
    this.setState({
      request: "",
      response: "",
    });
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    let filter = this.state.resultTraza[indextraza]
    console.log(filter.id);
    if (filter !== null && filter !== undefined) {
      fetch(endpoint + "/" + params.engineId + '/history/' + filter.id + '/origin/' + boxName,requestOptions)
      .then((result) => result.json().then((response) => {
        let reqeustResponseJson = response.txHistory[0]
        if(reqeustResponseJson){
          this.setState({
            request: reqeustResponseJson.jsonRequest,
            response: reqeustResponseJson.jsonResponse,
          });
        }
      }))      
      .catch(error => {
        console.log("Hubo un problema con la petición Fetch:" + error.message);
        this.setState({
          isOpen: true,
          modalChildren: "error",
          isClosable: true,
        });
      })
    } else {
      this.setState({
        isOpen: true,
        modalChildren: "notFound",
        isClosable: true,
      });
    }
  }

  searchBox = (endpoint, engineId) => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    fetch(endpoint + "/" + engineId + "/events", requestOptions)
      .then((result) => result.json())
      .then((response) => {
        this.setState({ resultsBox: response.eventFlow });
      });
  };

  searchTrazaDetail(endpoint, engineId) {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    fetch(endpoint + "/" + engineId + "/history/lazy", requestOptions)
      .then((result) => result.json())
      .then((response) => {
        this.setState({ resultTraza: response.txHistory });
      });
  }

  /**
   * Obtiene el detalle de medios de pago para una operacion
   */
  searchDetailPayment = (endpoint, idOrder) => {
    let paymentDetailResponse = [];

    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    fetch(endpoint + "/" + idOrder, requestOptions)
      .then((result) => result.json())
      .then((response) => {
        let i = 0;
        for (i = 0; i < response.length; i++) {
          paymentDetailResponse.push({
            amount: response[i]["amount"],
            number: response[i]["number"],
            dueDate: response[i]["dueDate"],
            autorizationCode: response[i]["autorizationCode"],
            payerNid: response[i]["payerNid"],
            payerName: response[i]["payerName"],
            depositor: response[i]["depositor"],
            bank: response[i]["bank"],
            quotas: response[i]["quotas"],
          });
        }
        this.setState({ paymentdetail: paymentDetailResponse });
      });
  };

  /**
   * Obtiene el detalle de transacciones para una operacion
   */
  searchDetailTransaction = (endpoint, idOrder) => {
    let trxDetailResponse = [];

    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    fetch(endpoint + "/" + idOrder, requestOptions)
      .then((result) => result.json())
      .then((response) => {
        let i = 0;
        for (i = 0; i < response.length; i++) {
          trxDetailResponse.push({
            amount: response[i]["amount"],
            contractNumber: response[i]["contractNumber"],
            nid: response[i]["nid"],
            origin: response[i]["origin"],
            originId: response[i]["originId"],
            transactionId: response[i]["transactionId"],
            transactionType: response[i]["transactionType"],
          });
        }
        this.setState({ trxdetail: trxDetailResponse });
      });
  };

  render(props) {
    return (
      <Fragment style={{ maxWidth: '1020px', overflowY:'auto'}}>
        <FormBlock style={{ maxWidth: '1020px', overflowY:'auto'}}>
              <Detail style={{ maxWidth: '80%'}}>
                <FormTitle>Detalle de Operación {this.state.idOrder}</FormTitle>
                <DetailFlowContent>
                  {this.state.resultsBox.map((box, indexbox) => {
                    if (!isPendiente(this.state.resultTraza, box.name)) {
                      return this.state.resultTraza.map((traza, indextraza) => {
                        if (box.name === traza.engineStatus) {
                          console.log("Fecha: " + traza.fechaActualizacion)
                          var fechaFormateada = format(new Date(traza.fechaActualizacion), "dd/MM/yyyy HH:mm:ss");
                          var statusBox = "200";
                          if (traza.status != null) {
                            statusBox = traza.status.status;
                          }

                          return (
                            <Fragment>
                              <div
                                onClick={() => {
                                  let endponintHistory = `${API_URL_MOTOR}/api/instance`
                                this.searchHistory(endponintHistory,this.props.otroDato,box.name,indextraza)
                                  this.setState({
                                    isOpen: true,
                                    modalChildren: "requestModal",
                                    isClosable: true,
                                  });
                                }}
                                style={{
                                  borderRadius: "85px",
                                  cursor: "pointer",
                                }}
                              >
                                <CajaFlujo
                                  name={box.name.replace(/\_/g, " ")}
                                  exist={isPendiente(
                                    this.state.resultTraza,
                                    box.name
                                  )}
                                  fechaActualizacion={fechaFormateada}
                                  status={statusBox}
                                />
                              </div>
                              <Separador data={box.name} />
                            </Fragment>
                          );
                        }
                      });
                    } else {
                      return (
                        <Fragment>
                          <CajaFlujo
                            name={box.name.replace(/\_/g, " ")}
                            exist={isPendiente(this.state.resultTraza, box.name)}
                          />
                        </Fragment>
                      );
                    }
                  })}
                </DetailFlowContent>
              </Detail>

          <ButtonBlock>
            <Buttons.Primary onClick={() => {
              this.props.action(true);
              this.setState({ mostrarComponente: false })
            }}>Volver</Buttons.Primary>
          </ButtonBlock>
        </FormBlock>
        <Modal
          isDetail
          show={this.state.isOpen}
         
          onClose={() => {
            this.state.isClosable
              ? this.setState({
                  isOpen: !this.state.isOpen,
                })
              : console.warn("worker on something...");
          }}
        >
          <Template name={this.state.modalChildren}  request={this.state.request ? this.state.request : "Problemas al buscar request"}
          response={this.state.response ? this.state.response : "Problemas al buscar response"} />
        </Modal>
      </Fragment>
    );
  }
}

const isPendiente = (array, name) => {
  let existe = true;

  array.find((element) => {
    if (element.engineStatus == name) {
      existe = false;
    }
  });
  return existe;
};

const Separador = ({ data }) => {
  if (data != "Fin_Flujo") {
    return (
      <React.Fragment>
        <FlowDetailBlock>
          <FlowDetailBlockImg src="/images/arrow.svg" />
        </FlowDetailBlock>
      </React.Fragment>
    );
  } else {
    return <React.Fragment></React.Fragment>;
  }
};

const CajaFlujo = (props) => {
  if (props.exist == false && props.status == "200") {
    return (
      <DetailBlockItemGreen>
        <DetailBlockItemImg src="/images/ok.png" />
        <DetailBlockItemTitle>{props.name}</DetailBlockItemTitle>
        <DetailBlockItemDate>{props.fechaActualizacion}</DetailBlockItemDate>
      </DetailBlockItemGreen>
    );
  } else if (props.exist == false && props.status != "200") {
    return (
      <DetailBlockItemRed>
        <DetailBlockItemImg src="/images/error.png" />
        <DetailBlockItemTitle>{props.name}</DetailBlockItemTitle>
        <DetailBlockItemDate>{props.fechaActualizacion}</DetailBlockItemDate>
      </DetailBlockItemRed>
    );
  } else {
    return (
      <DetailBlockItemBlue>
        <DetailBlockItemImg src="/images/process.png" />
        <DetailBlockItemTitle>{props.name}</DetailBlockItemTitle>
        <DetailBlockItemDate>{props.fechaActualizacion}</DetailBlockItemDate>
      </DetailBlockItemBlue>
    );
  }
};

export default DetailComponent;
